import { render } from "./PopupShareReportQueueDetail.vue?vue&type=template&id=41c07033"
import script from "./PopupShareReportQueueDetail.vue?vue&type=script&lang=js"
export * from "./PopupShareReportQueueDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__